import { Inject, LOCALE_ID, Optional, Pipe, PipeTransform } from '@angular/core';
import { ZuoraDatePipeOptions } from '../interfaces/ZuoraDatePipeOptions';

@Pipe({
    name: 'zuoraDate'
})
export class ZuoraDatePipe implements PipeTransform {
    constructor(@Optional() @Inject(LOCALE_ID) private _locale?: string) { }

    transform(value: any, args?: ZuoraDatePipeOptions): any {
        try {
            const valueAsDate = this.convertToDate(value);

            const userOpts = args as ZuoraDatePipeOptions;
            const defaultOpts = {year: '2-digit', month: 'numeric', day: 'numeric'};
            const opts = Object.assign({}, defaultOpts, userOpts);

            return new Intl.DateTimeFormat(this._locale, opts).format(valueAsDate);
        } catch (e) {
            return value.toString();
        }
    }

    /*
        Sometimes JS is awful, handles for 'YYYY-MM-DD' to choose local timezone instead of UTC
        https://stackoverflow.com/questions/2587345/why-does-date-parse-give-incorrect-results
     */
    private convertToDate(input: any) {
        if (this.isIsoUtc(input)) {
            const splitString = input.split('-');
            return new Date(Number(splitString[0]), Number(splitString[1]) - 1, Number(splitString[2]));
        } else {
            return new Date(input);
        }
    }

    private isIsoUtc(input: string): boolean {
        return typeof input === 'string' && input.charAt(4) === '-' && input.charAt(7) === '-' && input.length === 10;
    }
}
